/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchDeals200ResponseInnerJournalEntriesInner
 */
export interface SearchDeals200ResponseInnerJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'invalidTaxCodeCause': SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'description': string | null;
}

export const SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum];


